var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("insert.periodicSalesComparison.StatusId")
                      ) + ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.periodicSalesComparison.Code")) +
                        ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.periodicSalesComparison.Definitions"),
                  active: ""
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Description1,
                                "text",
                                "insert.periodicSalesComparison.Description1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Definition,
                                "text",
                                "insert.periodicSalesComparison.Definition"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PastSaleStartDate,
                                "date",
                                "insert.periodicSalesComparison.PastSalesStart"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PastSaleEndDate,
                                "date",
                                "insert.periodicSalesComparison.PastSalesEnd"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PastSaleQuantity,
                                "text",
                                "insert.periodicSalesComparison.PastSalesControlAmount"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BranchCriteria,
                                "object",
                                "insert.periodicSalesComparison.BranchCriterion"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.NextSaleStartDate,
                                "date",
                                "insert.periodicSalesComparison.NextSalesStart"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.NextSaleEndDate,
                                "date",
                                "insert.periodicSalesComparison.NextSalesEnd"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.NextSaleQuantity,
                                "text",
                                "insert.periodicSalesComparison.NextSalesControlAmount"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ItemCriteria,
                                "object",
                                "insert.periodicSalesComparison.ProductCriteria"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PastSaleColor,
                                "object",
                                "insert.periodicSalesComparison.PastSaleColor"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.NextSaleColor,
                                "object",
                                "insert.periodicSalesComparison.NextSaleColor"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.rowData.ItemCriteriaId === 24
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.periodicSalesComparison.Products")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.fixedTermCampaign.areaDescription"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.fixedTermCampaign.value"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData
                                          .PeriodicSalesComparisonDetails
                                          ? _vm.rowData.PeriodicSalesComparisonDetails.filter(
                                              function(p) {
                                                return p.TableName == "T_ITEM"
                                              }
                                            )
                                          : [],
                                        function(p, i) {
                                          return _c(
                                            "b-tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(_vm._s(p.ColumnNameDesc))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(p.ColumnValueDesc)
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.ItemCriteria && _vm.rowData.ItemCriteria.Code === "UL"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      lazy: "",
                      title: _vm.$t("insert.itemAnalysis.itemList")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.itemAnalysisItems
                                  },
                                  model: {
                                    value: _vm.rowData.periodicSalesItems,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "periodicSalesItems",
                                        $$v
                                      )
                                    },
                                    expression: "rowData.periodicSalesItems"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.BranchCriteriaId === 30
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.periodicSalesComparison.Branches")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.fixedTermCampaign.branchCode"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.fixedTermCampaign.branchName"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData
                                          .PeriodicSalesComparisonDetails
                                          ? _vm.rowData.PeriodicSalesComparisonDetails.filter(
                                              function(b) {
                                                return b.TableName == "T_BRANCH"
                                              }
                                            )
                                          : [],
                                        function(b, i) {
                                          return _c(
                                            "b-tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(_vm._s(b.Code))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(_vm._s(b.Description1))
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-052dfa6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052dfa6d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PeriodicSalesComparison/get.vue
// module id = null
// module chunks = 